// THAT'S ONLY TEMP SOLUTION UNTIL WE'LL HAVE REAL BRAND PAGES
export default (state, { routeId }) => `${routeId}_SUCCESS_PAGE`
